var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 100.0 124.43044619422572",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l100.0 0l0 124.43044l-100.0 0l0 -124.43044z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l100.0 0l0 124.43044l-100.0 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1c232",
    d: "m24.336407 82.8939l0 0c0 -14.172348 11.488956 -25.661304 25.6613 -25.661304l0 0c6.8058014 0 13.332851 2.7035942 18.145283 7.5160255c4.8124237 4.8124237 7.5160217 11.339478 7.5160217 18.145279l0 0c0 14.17234 -11.48896 25.6613 -25.661304 25.6613l0 0c-14.172344 0 -25.6613 -11.48896 -25.6613 -25.6613zm12.83065 0l0 0c0 7.086174 5.74448 12.83065 12.83065 12.83065c7.086174 0 12.83065 -5.7444763 12.83065 -12.83065c0 -7.086174 -5.7444763 -12.83065 -12.83065 -12.83065l0 0c-7.08617 0 -12.83065 5.7444763 -12.83065 12.83065z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f1c232",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m24.336407 82.8939l0 0c0 -14.172348 11.488956 -25.661304 25.6613 -25.661304l0 0c6.8058014 0 13.332851 2.7035942 18.145283 7.5160255c4.8124237 4.8124237 7.5160217 11.339478 7.5160217 18.145279l0 0c0 14.17234 -11.48896 25.6613 -25.661304 25.6613l0 0c-14.172344 0 -25.6613 -11.48896 -25.6613 -25.6613zm12.83065 0l0 0c0 7.086174 5.74448 12.83065 12.83065 12.83065c7.086174 0 12.83065 -5.7444763 12.83065 -12.83065c0 -7.086174 -5.7444763 -12.83065 -12.83065 -12.83065l0 0c-7.08617 0 -12.83065 5.7444763 -12.83065 12.83065z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1c232",
    d: "m1.9594584 47.363045l0 0c0 -2.2779388 1.8466318 -4.124569 4.1245675 -4.124569l87.820244 0c1.0939026 0 2.1429977 0.43455124 2.916504 1.2080574c0.77350616 0.77350616 1.2080612 1.8226051 1.2080612 2.9165115l0 16.497772c0 2.2779388 -1.8466339 4.124565 -4.124565 4.124565l-87.820244 0c-2.2779357 0 -4.1245675 -1.8466263 -4.1245675 -4.124565z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f1c232",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m1.9594584 47.363045l0 0c0 -2.2779388 1.8466318 -4.124569 4.1245675 -4.124569l87.820244 0c1.0939026 0 2.1429977 0.43455124 2.916504 1.2080574c0.77350616 0.77350616 1.2080612 1.8226051 1.2080612 2.9165115l0 16.497772c0 2.2779388 -1.8466339 4.124565 -4.124565 4.124565l-87.820244 0c-2.2779357 0 -4.1245675 -1.8466263 -4.1245675 -4.124565z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1c232",
    d: "m1.9594584 102.21248l0 0c0 -2.2779388 1.8466318 -4.124565 4.1245675 -4.124565l87.820244 0c1.0939026 0 2.1429977 0.43454742 2.916504 1.2080536c0.77350616 0.77350616 1.2080612 1.822609 1.2080612 2.9165115l0 16.497772c0 2.2779388 -1.8466339 4.1245728 -4.124565 4.1245728l-87.820244 0c-2.2779357 0 -4.1245675 -1.8466339 -4.1245675 -4.1245728z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f1c232",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m1.9594584 102.21248l0 0c0 -2.2779388 1.8466318 -4.124565 4.1245675 -4.124565l87.820244 0c1.0939026 0 2.1429977 0.43454742 2.916504 1.2080536c0.77350616 0.77350616 1.2080612 1.822609 1.2080612 2.9165115l0 16.497772c0 2.2779388 -1.8466339 4.1245728 -4.124565 4.1245728l-87.820244 0c-2.2779357 0 -4.1245675 -1.8466339 -4.1245675 -4.1245728z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1c232",
    d: "m92.717476 46.314365l0 0c2.9405441 0 5.3243256 2.3837776 5.3243256 5.3243217l0 62.152405c0 1.4121017 -0.56095123 2.7663574 -1.5594559 3.764862c-0.99850464 0.99850464 -2.352768 1.5594635 -3.7648697 1.5594635l-21.296654 0c-2.9405441 0 -5.3243256 -2.3837814 -5.3243256 -5.3243256l0 -62.152405c0 -2.9405441 2.3837814 -5.3243217 5.3243256 -5.3243217z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f1c232",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m92.717476 46.314365l0 0c2.9405441 0 5.3243256 2.3837776 5.3243256 5.3243217l0 62.152405c0 1.4121017 -0.56095123 2.7663574 -1.5594559 3.764862c-0.99850464 0.99850464 -2.352768 1.5594635 -3.7648697 1.5594635l-21.296654 0c-2.9405441 0 -5.3243256 -2.3837814 -5.3243256 -5.3243256l0 -62.152405c0 -2.9405441 2.3837814 -5.3243217 5.3243256 -5.3243217z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1c232",
    d: "m28.394905 46.502205l0 0c2.915472 0 5.278927 2.3634567 5.278927 5.278927l0 62.2432c0 1.4000549 -0.5561714 2.742775 -1.5461617 3.7327652c-0.98999023 0.98999023 -2.3327065 1.5461578 -3.7327652 1.5461578l-21.115078 0c-2.915471 0 -5.278928 -2.3634567 -5.278928 -5.278923l0 -62.2432c0 -2.9154701 2.3634567 -5.278927 5.278928 -5.278927z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f1c232",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m28.394905 46.502205l0 0c2.915472 0 5.278927 2.3634567 5.278927 5.278927l0 62.2432c0 1.4000549 -0.5561714 2.742775 -1.5461617 3.7327652c-0.98999023 0.98999023 -2.3327065 1.5461578 -3.7327652 1.5461578l-21.115078 0c-2.915471 0 -5.278928 -2.3634567 -5.278928 -5.278923l0 -62.2432c0 -2.9154701 2.3634567 -5.278927 5.278928 -5.278927z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f1c232",
    d: "m9.2115755 42.372757l0 0c0 -14.581932 7.786393 -28.05407 20.42141 -35.33343c12.635017 -7.2793636 28.195415 -7.2579246 40.81032 0.05622816c12.614914 7.3141527 20.364151 20.807695 20.323967 35.389572l-13.344116 -0.03677368l0 0c0.027030945 -9.810101 -5.186348 -18.888018 -13.673153 -23.808687c-8.486805 -4.9206696 -18.95522 -4.935093 -27.455551 -0.037828445c-8.500334 4.8972645 -13.7387085 13.960781 -13.7387085 23.77092z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#f1c232",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m9.2115755 42.372757l0 0c0 -14.581932 7.786393 -28.05407 20.42141 -35.33343c12.635017 -7.2793636 28.195415 -7.2579246 40.81032 0.05622816c12.614914 7.3141527 20.364151 20.807695 20.323967 35.389572l-13.344116 -0.03677368l0 0c0.027030945 -9.810101 -5.186348 -18.888018 -13.673153 -23.808687c-8.486805 -4.9206696 -18.95522 -4.935093 -27.455551 -0.037828445c-8.500334 4.8972645 -13.7387085 13.960781 -13.7387085 23.77092z",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.6c93650d0e44aa624eb7594cd432127c.svg";
export { ForwardRef as ReactComponent };